function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 24.26c0-.397.32-.718.714-.718h4.675c.395 0 .715.321.715.717 0 .397-.32.718-.715.718h-4.675A.716.716 0 0127 24.26zM18 34.127h14.5v1.44H18v-1.44zM26.612 10.518c0-.816.659-1.478 1.471-1.478h4.565c.914 0 1.743.54 2.114 1.38l.002.004 3.747 8.62c.431.977-.283 2.076-1.345 2.076h-9.083a1.475 1.475 0 01-1.471-1.478v-9.124zm11.245 8.815l-.654.287-3.748-8.619a.883.883 0 00-.807-.525h-4.565a.043.043 0 00-.042.042v9.124c0 .023.02.042.042.042h9.083a.038.038 0 00.02-.004.047.047 0 00.015-.015.046.046 0 00.008-.02c0-.004 0-.01-.004-.02l.652-.292z",
  fill: "#2D2D2D"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.656 7.435a.043.043 0 00-.043.043v26.61c0 .023.02.042.043.042h4.541c.395 0 .715.322.715.718 0 .396-.32.718-.715.718H4.656a1.475 1.475 0 01-1.472-1.478V7.478c0-.816.66-1.478 1.472-1.478h28.787a5.339 5.339 0 014.88 3.185L43.11 20.01v.001a.063.063 0 00.009.014l3.541 4.269c.22.265.341.6.341.945v8.849c0 .816-.659 1.478-1.471 1.478h-4.541a.716.716 0 01-.715-.718c0-.396.32-.718.715-.718h4.541c.023 0 .042-.019.042-.042v-8.849a.041.041 0 00-.01-.027l-3.542-4.27a1.501 1.501 0 01-.212-.34l-.002-.005-4.79-10.829a3.91 3.91 0 00-3.573-2.333H4.656z",
  fill: "#2D2D2D"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.03 25.724c0-.816.659-1.477 1.471-1.477h3.733c.395 0 .715.32.715.717 0 .396-.32.718-.715.718h-3.733a.043.043 0 00-.042.042v1.52c0 .024.019.044.042.044h3.785c.395 0 .714.32.714.717 0 .396-.32.718-.714.718H42.5a1.475 1.475 0 01-1.471-1.478v-1.52zM22.157 6c.394 0 .714.321.714.718v13.555c0 .396-.32.718-.714.718a.716.716 0 01-.715-.718V6.718c0-.397.32-.718.715-.718zM36.65 31.427a3.35 3.35 0 100 6.7 3.35 3.35 0 000-6.7zM32 34.777a4.65 4.65 0 119.3 0 4.65 4.65 0 01-9.3 0z",
  fill: "#2D2D2D"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.65 31.427a3.35 3.35 0 100 6.7 3.35 3.35 0 000-6.7zM32 34.777a4.65 4.65 0 119.3 0 4.65 4.65 0 01-9.3 0z",
  fill: "#2D2D2D"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.7 34.127a.6.6 0 100 1.2.6.6 0 000-1.2zm-1.9.6a1.9 1.9 0 113.8 0 1.9 1.9 0 01-3.8 0zM13.65 31.427a3.35 3.35 0 100 6.7 3.35 3.35 0 000-6.7zM9 34.777a4.65 4.65 0 119.3 0 4.65 4.65 0 01-9.3 0z",
  fill: "#2D2D2D"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7 34.127a.6.6 0 100 1.2.6.6 0 000-1.2zm-1.9.6a1.9 1.9 0 113.8 0 1.9 1.9 0 01-3.8 0zM2.866 40.533c0-.335.272-.607.607-.607h4.665a.606.606 0 110 1.213H3.473a.607.607 0 01-.607-.606zM1 37.734c0-.335.272-.607.607-.607h1.866a.606.606 0 110 1.213H1.607A.607.607 0 011 37.734z",
  fill: "#2D2D2D"
});
function SvgTruckDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
export default __webpack_public_path__ + "/img/truck-delivery.svg";
export { SvgTruckDelivery as ReactComponent };